module.exports = __webpack_public_path__ + "static/media/mac_screen_full_no_background_crop_web.c9b8f45f.png";